$(function () {
  $('.aw-recruit__article__headline').on('click', function () {
    $(this).parent().find('.aw-recruit__article--close').fadeIn();
    $(this).parent().find('.aw-recruit__article__table').fadeIn();

    $(this).parent().find('.aw-recruit__article__member__table').fadeIn();
    $(this).parent().find('.aw-recruit__article__member__table').addClass('flexbox');
  });

  $('.aw-recruit__article--close').on('click', function () {
    $(this).parent().find('.aw-recruit__article--close').fadeOut();
    $(this).parent().find('.aw-recruit__article__table').fadeOut();

    $(this).parent().find('.aw-recruit__article__member__table').fadeOut();

    $(this).parent().find('.aw-recruit__article__member__table').removeClass('flexbox');
  });
});